import * as _ from 'lodash';
// TODO: Finish billing code validation
// import ErrorResponse from 'src/models/ErrorResponse';
import React, { useEffect, useState } from 'react';
// import State from 'src/models/State';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
// import Client from 'src/models/AP/Client';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
// import PagedResultSet from 'src/models/common/PagedResultSet';
import FindPersonDialog from 'src/components/accounts-payable/dialogs/FindPersonDialog';
// import WarningDialog from '../dialogs/WarningDialog';
// import ReportOptionsDialog from '../dialogs/ReportOptionsDialog';
// import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
// icons
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import { FaTrash } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { GiStoneBust } from 'react-icons/gi';
import { GiStockpiles } from 'react-icons/gi';
import { GiMoneyStack } from 'react-icons/gi';
import { VscGraph } from 'react-icons/vsc';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import FindClientDialog from  '../dialogs/FindClientDialog';
import TsdiClient from 'src/models/AP/Client';
import ChargeIndividual from 'src/models/AP/ChargeIndividual';
import ClientLandman from 'src/models/ClientLandman';
import Card from 'src/components/common/Card.redesign';
import ClientContact from 'src/models/ClientContact';
import { AnyObject } from 'final-form';
import Address from 'src/models/Address';
import State from 'src/models/State';
import PhoneNumber from 'src/models/PhoneNumber';
import CPNavBar from '../CPNavBar';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import TsdiClientPermissions from 'src/models/AP/ClientPermission';

interface IClientContactPageProps {
    clientContacts: Array<ClientLandman | AnyObject>;
    setNewContactForm: (value: boolean) => void;
}

const ClientContactPage = (props: IClientContactPageProps) => {
    const dispatch = useDispatch();
    const { get, post, del, put, response } = useFetch();
    const { reset, register, /*setValue, getValues,*/ handleSubmit, formState, errors } = useForm();
    const { reset: resetClientForm, register: registerClientForm } = useForm();
    const [clientContactIndex, setClientContactIndex] = useState<number>(0);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [dudleyStatus, setDudleyStatus] = useState<boolean>(false);
    const [landmanSearchOptions, setLandmanSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [landmanSearchTerm, setLandmanSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [clientLandMen, setClientLandMen] = useState<Array<ChargeIndividual> | Array<ClientLandman>>(undefined);
    const [clientContacts, setClientContacts] = useState<Array<ChargeIndividual> | Array<ClientLandman>>(undefined);
    const [selectedClientLandMan, setSelectedClientLandMan] = useState<ClientLandman | ChargeIndividual>(undefined);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const { isDirty, dirtyFields } = formState;
    const [clientPermissions, setClientPermissions] = useState<TsdiClientPermissions[]>(undefined);

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientContacts) {
            setSelectedClientLandMan(clientContacts[0]);
            populateForm();
        }
    }, [clientContacts]);

    useEffect(() => {
        if (clientContactIndex !== undefined && !!clientContacts && clientContacts.length > clientContactIndex) {
            reset(clientContacts[clientContactIndex]);
            setDudleyStatus((clientContacts[clientContactIndex] as ClientLandman).status);
            getClientPermissions();
        }
    }, [clientContactIndex]);
    
    useEffect(() => {
        if (!!clientLandMen) {
            getClientContacts();
        }
    }, [clientLandMen]);

    useEffect(() => {
        if (!!selectedClient) {
            resetClientForm(selectedClient);
            getClientContacts();
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!selectedClientLandMan && !!clientLandMen && clientLandMen?.length === 1) {
            reset(selectedClientLandMan);
        } else if (!!selectedClientLandMan) {
            getClientPermissions();
        }
    }, [selectedClientLandMan]);

    useEffect(() => {
        if (!!landmanSearchTerm || landmanSearchTerm === '') {
            resetLandmanSearchOptions();
        }
    }, [landmanSearchTerm]);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!landmanSearchOptions) {
            getClientLandMen();
        }
    }, [landmanSearchOptions]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    const initializeLandmanSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'LM_NO',
            pageNumber: 1,
            columns: []
        };
        if (!!selectedClient && !isNaN(Number(selectedClient?.clientNumber))) {
            // tslint:disable-next-line:max-line-length
            setLandmanSearchOptions(ODataOptions.from(tableConfig).addOrderBy('LNAME', ODataOrderByDirection.Ascending).addFilter(new ODataFilter('clm.[CL_NO]', ODataFilterOperators.Equals, selectedClient?.clientNumber)));
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const addClientContact = async (payload: ClientContact) => {
        let result = await post(`/v1.0/AccountsPayable/clients`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    };

    const deleteClientContact = async () => {
        let result = await del(`/v1.0/ClientProjectMaintenance/client/${selectedClientLandMan.clientNumber}/contact/${(clientContacts[clientContactIndex] as ClientLandman).number}`);

        if (!response.ok) {
            alert('Unable to delete client contact: ' + result);
        } else {
            getClientContacts();
        }
    };

    const createClientContact = async (data: ClientContact) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/client/contact`, data);

        if (!response.ok) {
            alert('Unable to create client contact data: ' + result);
        } else {
            getClientContacts();
        }
    };

    const updateClientContact = async (data: ClientContact) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/client/contact`, data);

        if (!response.ok) {
            alert('Unable to update client contact data: ' + result);
        } else {
            getClientContacts();
        }
    };

    const populateForm = () => {
        const clientLandman = clientContacts[0] as ClientLandman;
        const clientLandmanAddress = new Address();
        const clientLandmanState = new State();
        const clientLandmanPhone = new PhoneNumber();
        clientLandmanPhone.number = clientLandman.officePhone;
        clientLandmanState.name = clientLandman.clientState;
        clientLandmanAddress.addressLine1 = clientLandman.clientAddress;
        clientLandmanAddress.addressLine2 = clientLandman.clientAddress2;
        clientLandmanAddress.city = clientLandman.clientCity;
        clientLandmanAddress.state = clientLandmanState;

        const data: ClientLandman = {
            id: clientLandman.id,
            number: clientLandman.number,
            lastName: clientLandman.lastName,
            firstName: clientLandman.firstName,
            clientCity: clientLandman.clientCity,
            clientState: clientLandman.clientState,
            clientAddress: clientLandmanAddress.addressLine1,
            clientAddress2: clientLandmanAddress.addressLine2,
            title: clientLandman.title,
            salutation: clientLandman.salutation,
            cellPhone: clientLandmanPhone?.number?.toString(),
            officePhone: clientLandmanPhone.number,
            officePhoneExt: clientLandman.officePhoneExt,
            homeEmail: clientLandman.homeEmail,
            businessEmail: clientLandman.businessEmail,
            clientNumber: clientLandman.clientNumber,
            clientName: clientLandman.clientName,
            fax: clientLandman.fax,
            whereNow: clientLandman.whereNow,
            personalCellPhone: clientLandman.personalCellPhone,
            homeAddress: clientLandman.homeAddress2,
            homeAddress2: clientLandman.homeAddress2,
            homeCity: clientLandman.homeCity,
            homeState: clientLandman.homeState,
            homeZipCode: clientLandman.homeZipCode,
            certifications: clientLandman.certifications,
            comments: clientLandman.comments,
            status: clientLandman.status
        };

        reset(data);
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VouchersPage onCreate()');
        getClients();
        initializeClientSearchSettings();
        initializeLandmanSearchSettings();
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

/*     const displayWarning = (index: number) => {
        setSelectedIndividualIndex(index);
        showDialog(DialogList.WARNING);
    };

    const displayVoidWarning = () => {
        setVoidingVoucher(true);
        showDialog(DialogList.WARNING);
    }; */

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const chooseVouchers = () => {
        showDialog(DialogList.CHOOSE_VOUCHERS_TO_PAY);
    };

    const handleWriteCheck = () => {
        showDialog(DialogList.ENTER_CHECK_NUMBER);
    };

    const onSubmit = async (data: ClientContact) => {
        if (!!data && isDirty) {
            const finalData = finalizeData(data);
            if (!!finalData?.number) {
                updateClientContact(finalData);
            } else {
                createClientContact(finalData);
            }
        }
    };

    const finalizeData = (data: ClientContact) => {
        // Get all the form values, then add in the Personnel model values that the form doesn't have
        let finalData: ClientContact = {
            clientNumber: selectedClient?.clientNumber,
            number: Number(data.number),
            firstName: data.firstName,
            lastName: data.lastName,
            address: data.address,
            address2: data.address2,
            zipCode: data.zipCode,
            city: data.city,
            title: data.title,
            salutation: data.salutation,
            homeAddress: data.homeAddress,
            homeAddress2: data.homeAddress2,
            homeCity: data.homeCity,
            homeState: data.homeState,
            employeeNumber: !!data.number ? data.number : null,
            state: data.state,
            homePhone: data.homePhone,
            fax: data.fax,
            emailAddress: data.emailAddress,
            officeEmailAddress: data.officeEmailAddress,
            officePhone: data.officePhone,
            officeExt: data.officePhone,
            cellPhone: data.cellPhone,
            secName: data.secName,
            secPhone: data.secPhone,
            active: dudleyStatus,
            whereNow: data.whereNow,
            notes: data.notes,
            certifications: data.certifications,
            homeZipCode: data.homeZipCode
        };

        return finalData;
    };

/*     const getAccountInfo = async (voucherNumber: string, glAccountNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/voucherNumber/${voucherNumber}/glAccountNumber/${glAccountNumber}`);

        if (response.ok) {
            console.log('Got voucher Data!' + result);
        } else {
            console.log('Unable to get voucher Data!');
        }
    }; */

    // TODO: Finish billing code validation
    /*
    const getClient = async (clientNumber: number, index: number) => {
        let options = new ODataOptions();
        options.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, clientNumber));
        let result = await get(`/v1.0/AccountsPayable/client${options.toString()}`);

        let newClientVerifications = _.cloneDeep(clientValidations);
        if (response.ok) {
            if (!!result.clientNumber) {
                newClientVerifications.splice(index, 1, !!result.clientNumber ? true : false);
            }
        } else {
            newClientVerifications.splice(index, 1, false);
        }
        setClientValidations(newClientVerifications);
    };

     const getClients = async () => {
        let result = await get(`/v1.0/AccountsPayable/clients`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const handleApiError = (value: Response) => {
        console.log('api call failed: ' + value);
    };

    const handleApiCall = (value: Response) => {
        return new Promise<object>((resolve) => {
            if (value.ok) {
                value
                    .json()
                    .then((body) => resolve(body))
                    .catch(() => resolve(null));
            } else {
                resolve(value.json().then((errorResponse: ErrorResponse) => new ErrorResponse(errorResponse.messageCode, errorResponse.message)));
            }
        });
    };

    const getJwtToken = (): string => {
        return timeAndExpenseToken;
    };

    const createHeader = (type: string) => {
        let headers = {};

        // let jwtToken = getJwtToken();
        // jwt = undefined;

        const username = `Joe Example`;
        const password = `DudleyRocks025!`;
        if (type === 'jwt') {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                // 'Connection': 'keep-alive',
                // 'content-type': 'application/json',
                // Authorization: `Bearer ${jwt}`,
            };
        } else if (type === 'validateProspect') {
            headers =  {
                'Tsjwt': timeAndExpenseToken,
                'content-type': 'application/json'
              };
        } else {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                'content-type': 'application/json' };
        }

        return headers;
    };

    const getHeader = (jwt: string | undefined) => {
        const header: RequestInit = {
            headers: createHeader(jwt),
            method: 'GET',
            mode: 'cors',
        };
        return header;
    };

    const postHeader = (body: object, jwt: string | undefined = undefined) => {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: createHeader('validateProspect'),
            method: 'POST',
            mode: 'cors',
        };
        return header;
    };

    const getRequest = async (url: string, jwt: string | undefined = undefined) => {
        return fetch(url, getHeader(jwt)).then(handleApiCall).catch(handleApiError);
    };

    const postRequest = async (url: string, body: object, jwt: string | undefined = undefined) => {
        return fetch(url, postHeader(body, jwt)).then(handleApiCall).catch(handleApiError);
    };

    const baseCalmsServicesUrl = `https://services.calms.net`;
    const baseTandEUrl = `https://time.calms.net`;

    // https://services.calms.net/api/tokenissue

    const getTEUserToken = async () => {
        const result = await getRequest(`${baseCalmsServicesUrl}/api/tokenissue`, 'jwt');
        setTimeAndExpenseToken((result as {timeAndExpenseJwt: string}).timeAndExpenseJwt);
    }; */

    // TODO: Finish billing code validation
/*     const validateBillingCode = async (index: number) => {
        const formValues = getValues();
        console.log(index + ' ' + formValues);
        const payload = {
            'clientNumber': `${formValues.voucherExpenses[index].clientNumber}`,
            'prospectNumber': `${formValues.voucherExpenses[index].projectNumber}`,
            'sectionNumber': 0,
            'unitNumber': 0};
        let data = await postRequest(`${baseTandEUrl}/api/entry/validateProspect`, payload as object, 'validateProspect');
        if (response.ok && (!(data as {error: string})?.error || (data as {error: string})?.error?.length === 0)) {
            console.log('========> Received response from T&E Service', data);
        } else {
            let newClientVerifications = _.cloneDeep(clientValidations);
            newClientVerifications.splice(index, 1, false);
            // let newClientValidations = [];
            // newClientValidations.push({index: index, error: true});
            setClientValidations(newClientVerifications);
            const errorText = (data as {error: string})?.error;
            console.log('Unable to validate billing code.' + errorText);
            const errorTextElement = document.getElementById('BillingCodeError');
            errorTextElement.innerText = errorText;
            errorTextElement.setAttribute('style', 'display: block; color: red');
        }
    }; */

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getClientLandMen = async () => {
        let queryString = !!landmanSearchOptions?.toString() ? landmanSearchOptions?.toString() : '';
        let result = await get(`/v1.0/ClientProjectMaintenance/client/landmen${queryString}`);

        if (response.ok) {
            setClientLandMen(result?.items);
        } else {
            console.log('Unable to get client landmen Data!');
        }
    };

    const getClientPermissions = async () => {
        const contactId = clientContacts[clientContactIndex]?.id;
        if (!contactId) {
            return;
        }

        let result = await get(`/v1.0/ClientProjectMaintenance/client/${selectedClient?.clientNumber}/contact/${contactId}/permissions`);

        if (response.ok) {
            setClientPermissions(result);
        } else {
            console.log('Unable to get client landmen Data!');
        }
    };

    const getClientContacts = async () => {
        const tableConfig: ITableConfig = {
            rowCount: 1000,
            idField: 'CLM_NO',
            pageNumber: 1,
            columns: []
        };
        const dataOptions = ODataOptions.from(tableConfig).addOrderBy('LM_NO', ODataOrderByDirection.Ascending);
        if (!!selectedClient) {
            dataOptions.addFilter(new ODataFilter('clm.CL_NO', ODataFilterOperators.Equals, selectedClient?.clientNumber));
        }
        let queryString = !!dataOptions?.toString() ? dataOptions?.toString() : '';
        let result = await get(`/v1.0/ClientProjectMaintenance/client/landmen${queryString}`);

        if (response.ok) {
            setClientContacts(result?.items);
        } else {
            console.log('Unable to get client landmen Data!');
        }
    };

/*     const incrementClientContacts = () => {
        if (!!fetchNextVouchersPage) {
            let newSearchOptions = _.cloneDeep(voucherSearchOptions);
            newSearchOptions.incrementPageNumber();
            setVoucherSearchOptions(newSearchOptions);
        }
    }; */

    const resetLandmanSearchOptions = () => {
        setClientLandMen([]);
        setFetchNextPage(true);
        console.log(fetchNextPage);
        let newLandmanSearchOptions = _.cloneDeep(landmanSearchOptions);
        newLandmanSearchOptions.clearFilters();
        newLandmanSearchOptions.addPaging(1, 50);
        newLandmanSearchOptions.addFilter(new ODataFilter('LNAME', ODataFilterOperators.Contains, !!landmanSearchTerm ? landmanSearchTerm : ''));
        newLandmanSearchOptions.addFilter(new ODataFilter('FNAME', ODataFilterOperators.Contains, !!landmanSearchTerm ? landmanSearchTerm : ''));
        setLandmanSearchOptions(newLandmanSearchOptions);
    };

    const resetClientSearchOptions = () => {
        setFetchNextPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
                setClientSearchOptions(newClientSearchOptions);
            }
        }
    };

    const nextClientContact = () => {
        if ((clientContactIndex + 1) < clientContacts?.length) {
            setClientContactIndex(clientContactIndex + 1);
        } else {
            alert('No more client contacts!');
        }
    };

    const previousClientContact = () => {
        if ((clientContactIndex - 1) >= 0) {
            setClientContactIndex(clientContactIndex - 1);
        } else {
            alert('No more client contacts!');
        }
    };

    const moveToLastClientContact = () => {
        setClientContactIndex(clientLandMen?.length > 0 ? clientLandMen?.length - 1 : 0);
    };

    const moveToFirstClientContact = () => {
        setClientContactIndex(clientLandMen?.length > 0 ? clientLandMen?.length - 1 : 0);
    };

    const findClient = () => {
        console.log('Find Client Button Clicked');
        showDialog(DialogList.FIND_CLIENT);
    };

    const addRemoveBlacklist = () => {
        alert('Not yet implemented!');
    };

    const roleMaintenance = () => {
        alert('Not yet implemented!');
    };

    const ActivateDeactivateAccount = () => {
        alert('Not yet implemented!');
    };

    const displayClientContacts = () => {
        return (
            <>
            <form>
                <div style={{display: 'flex', marginTop: '1rem'}}>
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Contact No"
                        name={'number'}
                        style={{width: '200px'}}
                        register={register}
                        readOnly={true}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Find Client Contact"
                        reactIcon={BsSearch}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => findClient()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to First Client Contact"
                        reactIcon={BiArrowToLeft}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => moveToFirstClientContact}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Previous Contact"
                        reactIcon={BiLeftArrowAlt}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={previousClientContact}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Add New Client Contact"
                        reactIcon={BiAddToQueue}
                        iconHoverColor="blue"
                        iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                        onClick={() => clearForm()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Delete Client Contact"
                        reactIcon={FaTrash}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => deleteClientContact()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Save Changes"
                        reactIcon={FaRegSave}                        
                        type={'submit'}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => onSaveChanges()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Next Contact"
                        reactIcon={BiRightArrowAlt}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={nextClientContact}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Last Client Contact"
                        reactIcon={BiArrowToRight}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={moveToLastClientContact}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Scan for Client Landman"
                        
                        iconImage={`findLandman.png`}
                        iconHoverColor="blue"
                        iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                        onClick={() => findPerson()}
                    />
                    </div>
                    <div className="form-row"   style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Last Name"
                            name={`lastName`}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Office Phone"
                            name={'officePhone'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Extenstion"
                            name={'officePhoneExt'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="First Name"
                            name={'firstName'}
                            style={{width: '200px'}}
                            register={register}
                        />
                    </div>
                    <div style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Work Cell"
                            name={'cellPhone'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Address"
                            name={'clientAddress'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Personal Cell"
                            name={'cellPhone'}
                            style={{width: '200px'}}
                            register={register}
                        />
                    </div>
                    <div style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Address 2"
                            name={'clientAddress2'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Business Email"
                            name={'businessEmail'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <Button
                            className="blue-hover-button"
                            type="button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Add Account'}
                            onClick={() => findPerson()}
                        />
                    </div>
                    <div style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Zip Code"
                            name={'clientZipCode'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="User Name"
                            name={'userName'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <Button
                            className="blue-hover-button"
                            type="button"
                            style={{whiteSpace: 'nowrap', width: '24%', marginRight: '1rem' }}
                            text={'Reset Password'}
                            onClick={() => findPerson()}
                        />
                    </div>
                    <div style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="City"
                            name={'homeCity'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="State"
                            name={'homeState'}
                            style={{width: '20px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Account Status"
                            name={'dbAccountStatus'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <Button
                            className="blue-hover-button"
                            type="button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Activate/Deactivate'}
                            onClick={() => ActivateDeactivateAccount()}
                        />
                    </div>
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Title"
                        name={'title'}
                        style={{width: '200px'}}
                        register={register}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Salutation"
                        name={'salutation'}
                        style={{width: '200px'}}
                        register={register}
                    />
                    <div style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="homeAddress"
                            name={'homeAddress'}
                            style={{width: '200px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Certifications"
                            name={'certifications'}
                            style={{height: '40px', width: '200px'}}
                            register={register}
                        />
                    </div>
                    <div style={{display: 'flex', marginTop: '1rem'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Home Zip"
                            name={'homeZipCode'}
                            style={{width: '50px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="City"
                            name={'homeCity'}
                            style={{width: '20px'}}
                            register={register}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="State"
                            name={'homeState'}
                            style={{width: '20px'}}
                            register={register}
                        />
                        <Button
                            className="blue-hover-button"
                            type="button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Add/Remove Blacklist'}
                            onClick={() => addRemoveBlacklist()}
                        />
                        <Button
                            className="blue-hover-button"
                            type="button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Role Maintenance'}
                            onClick={() => roleMaintenance()}
                        />
                    </div>
                </form>            
            </>
        );
    };

    const displaySection2 = () => {
        return (
            <>
                <form>
                    <div style={{display: 'inline-block', marginTop: '1rem'}}>
                        <div style={{display: 'flex'}}>
                            <div style={{paddingRight: '20px'}}>
                                <RHFCheckbox
                                    label="Former Employee?"
                                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    name="status"
                                    checked={dudleyStatus}
                                    register={register}
                                    onChange={() => setDudleyStatus(!dudleyStatus)}
                                    bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                                    errors={errors}
                                />
                            </div>
                            <RHFInputBox
                                labelOnLeft={true}
                                label="Now Works For:"
                                name="whereNow"
                                style={{width: '60px'}}
                                register={register}
                                bodyStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            />
                        </div>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Comments"
                            name="notes"
                            style={{height: '60px', width: '400px'}}
                            register={register}
                        />
                    </div>
                </form>
            </>
        );
    };

    const renderClientContacts = () => {
        let openContactForm = () => {
            props?.setNewContactForm(true);
        };

        return clientPermissions ? (
            clientPermissions?.map((contact: TsdiClientPermissions, index: number) => {
                return (
                    <Card
                        className="small-input"
                        key={index}
                        style={{ backgroundColor: 'white', borderTop: '1px solid gray' }}
                        onClick={openContactForm}
                        badge={contact.userId ? `User ID: ${contact.userId}` : ''}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingTop: '1rem' }}>
                            <p style={{ width: '150px' }}>{contact?.clientNumber}</p>
                            <p style={{ width: '150px' }}>{contact?.projectNumber}</p>
                            <p style={{ width: '150px' }}>{contact?.clientName}</p>
                            <input style={{ width: '15px' }} type="checkbox" defaultChecked={contact.gisAccess} />
                            <input style={{ width: '15px' }} type="checkbox" defaultChecked={contact.dashboardAccess} />
                        </div>
                    </Card>
                );
            })
        ) : (
            <></>
        );
    };

    const clearForm = () => {
        reset(new ClientLandman());
    };

    const onSaveChanges = () => {
        if (isDirty) {
            console.log('Saving client contact changes for: ' + dirtyFields);
            addClientContact(new ClientContact());
        }
    };

    const findPerson = () => {
        console.log('Add Person Button Clicked');
        showDialog(DialogList.FIND_PERSON);
    };

    const handleSelectedPerson = async (person: ClientLandman) => {
        console.log('Selected landman: ' + person);
    };

    const displayTitle = () => {
        const title = 'Client Contacts';

        return title;
    };

    return (
        <div>
            <CPNavBar/>
            <ClientProjectSearch
                setSelectedClient={setSelectedClient}
                clients={clients}
                size={6}
            />
            <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id={`ClientContactForm`} onSubmit={handleSubmit(onSubmit)}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox                                        
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '10%'}}
                                                register={registerClientForm}
                                            />
                                            <RHFInputBox
                                                name={'clientName'}
                                                style={{width: '90%'}}
                                                bodyStyle={{width: '40%'}}
                                                register={registerClientForm}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Landman"
                                                
                                                iconImage={`findLandman.png`}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                                                onClick={() => findPerson()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client Contact"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstClientContact}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={previousClientContact}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Save Changes"
                                                reactIcon={FaRegSave}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => onSaveChanges()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={nextClientContact}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastClientContact}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Equipment Info & Rates"
                                                reactIcon={GiStockpiles}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => chooseVouchers()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing Accounts"
                                                reactIcon={GiMoneyStack}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => handleWriteCheck()}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={GiStoneBust}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => window.print()}
                                            />
                                        </div>                                    
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle="Client Information">
                                    <div style={{ padding: '.5rem' }}>
                                        <div style={{ border: 'solid rgb(99, 147, 193) 2px', overflowY: 'scroll', height: 'auto' }}>
                                            {displayClientContacts()}
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <div className="form-row" style={{ border: 'solid blue 1px', marginBottom: '0', height: 'auto' }}>
                                        <div style={{width: '100%', overflow: 'hidden' }}>
                                            {displaySection2()}
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <div style={{width: '100%', display: 'inline-block'}}>
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3rem 0 9rem' }}>
                                                <h3 style={{ marginLeft: '0' }}>Cl. No.</h3>
                                                <h3 style={{ marginLeft: '3rem' }}>Pr. No.</h3>
                                                <h3 style={{ marginLeft: '5rem' }}>Client Name</h3>
                                                <h3 style={{ marginRight: '-9rem' }}>GIS?</h3>
                                                <h3 style={{ marginLeft: '1rem' }}>Dash Board?</h3>
                                            </div>
                                        </div>
                                        <div style={{ border: 'solid 1px', textAlign: 'center', overflowY: 'scroll' }}>
                                            {renderClientContacts()}
                                        </div>
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
            <FindClientDialog 
                dialogName={DialogList.FIND_CLIENT} 
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedClient={setSelectedClient}
            />
            <FindPersonDialog
                dialogName={DialogList.FIND_PERSON}
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}
                populatePersonList={getClientLandMen}
                personList={clientLandMen}
                setPersonSearchTerm={setLandmanSearchTerm}
            />
        </div>
    );
};

export default ClientContactPage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/ClientContact.tsx